// 37 capabilities of the Clone AI — reformulated for commercial impact
// Proper French accents, human-readable wording

export const CAPABILITIES = {
  left: [
    { name: 'M\u00e9moriser chaque appel', x: -0.65, y: 0.4, z: 0.15 },
    { name: 'Lire et retenir vos emails', x: -0.9, y: 0.3, z: -0.1 },
    { name: 'Capter chaque SMS', x: -0.75, y: 0.2, z: 0.3 },
    { name: 'Suivre vos conversations WhatsApp', x: -1.0, y: 0.15, z: 0.05 },
    { name: 'Indexer vos documents', x: -0.7, y: 0.05, z: -0.25 },
    { name: 'Reconna\u00eetre vos interlocuteurs', x: -0.85, y: -0.05, z: 0.2 },
    { name: 'Fusionner les doublons', x: -1.05, y: 0.25, z: -0.05 },
    { name: 'D\u00e9tecter les promesses faites', x: -0.8, y: 0.35, z: 0.25 },
    { name: 'Signaler les points de blocage', x: -0.95, y: 0.08, z: -0.25 },
    { name: 'Retenir les faits importants', x: -0.7, y: -0.1, z: 0.1 },
    { name: 'Enregistrer chaque d\u00e9cision', x: -0.9, y: -0.12, z: -0.1 },
    { name: 'Organiser par dossier', x: -0.8, y: 0.05, z: 0.25 },
  ],
  right: [
    { name: 'Comprendre votre intention', x: 0.75, y: 0.35, z: 0.12 },
    { name: 'Identifier le bon interlocuteur', x: 0.9, y: 0.25, z: -0.08 },
    { name: 'Situer dans le temps', x: 0.7, y: 0.15, z: 0.25 },
    { name: '\u00c9valuer la pertinence', x: 0.95, y: 0.08, z: 0.05 },
    { name: 'R\u00e9sumer les \u00e9changes', x: 0.8, y: 0.0, z: -0.2 },
    { name: 'Lister sans doublons', x: 0.85, y: -0.1, z: 0.18 },
    { name: "R\u00e9pondre pour toute l'\u00e9quipe", x: 0.7, y: -0.05, z: -0.12 },
    { name: 'Adapter mon style de r\u00e9ponse', x: 1.0, y: 0.28, z: 0.0 },
    { name: 'Reproduire vos habitudes', x: 0.75, y: 0.2, z: -0.25 },
    { name: 'Respecter vos r\u00e8gles m\u00e9tier', x: 0.9, y: -0.05, z: -0.18 },
    { name: 'D\u00e9tecter votre langue', x: 0.8, y: 0.3, z: 0.22 },
    { name: 'Basculer entre les langues', x: 0.95, y: 0.15, z: 0.12 },
    { name: 'Parler avec ma voix', x: 0.7, y: 0.1, z: 0.08 },
    { name: 'Ne jamais inventer', x: 0.85, y: -0.15, z: 0.0 },
  ],
  bottom: [
    { name: 'Synchroniser vos appels', x: 0.36, y: 1.5, z: 0.08 },
    { name: 'Synchroniser vos emails', x: 0.18, y: 1.5, z: 0.32 },
    { name: 'Synchroniser votre CRM', x: -0.18, y: 1.5, z: 0.32 },
    { name: 'Transcrire chaque conversation', x: -0.36, y: 1.5, z: 0.08 },
    { name: 'D\u00e9couper les \u00e9changes audio', x: -0.28, y: 1.5, z: -0.22 },
    { name: 'Extraire les connaissances cl\u00e9s', x: 0.28, y: 1.5, z: -0.22 },
    { name: 'Agr\u00e9ger vos WhatsApp', x: 0.3, y: 1.5, z: 0.2 },
    { name: 'Surveiller les nouvelles donn\u00e9es', x: -0.3, y: 1.5, z: 0.2 },
    { name: 'Identifier automatiquement les contacts', x: -0.3, y: 1.5, z: -0.12 },
    { name: "Orchestrer les t\u00e2ches en arri\u00e8re-plan", x: 0.0, y: 1.5, z: 0.28 },
    { name: "Filtrer le bruit et l'inutile", x: 0.0, y: 1.5, z: -0.28 },
  ],
};

export const TRANSITIONS = {
  accroche: "Je suis votre clone. Je ne dors jamais, je n'oublie rien, et je parle 95 langues. Voici ce que je sais faire.",
  workers: "Pendant que vous dormez, moi je travaille.",
  memoire: "Chaque appel, chaque email, chaque mot. Je retiens tout.",
  intelligence: "Vous posez la question. Je fais le reste.",
  vocal: "Et je parle votre langue. Toutes vos langues.",
  cloture: "Et demain, j'en saurai encore plus.",
};

export const CAMERA_WAYPOINTS = {
  idle:   { pos: [0, 2.5, 8],      target: [0, 0, 0] },
  intro:  { pos: [0, 1.2, 6.0],    target: [0, 0, 0] },
  left:   { pos: [-3.8, 0.8, 4.5], target: [-1.5, 0.1, 0] },
  right:  { pos: [3.8, 0.8, 4.5],  target: [1.5, 0.15, 0] },
  bottom: { pos: [0, 2.5, 5.0],    target: [0, 1.5, 0] },
  finale: { pos: [0, 0.5, 6.0],    target: [0, -0.8, 0] },
  vocal:  { pos: [0, -0.5, 4.5],   target: [0, -1.8, 0] },
};

export const PHASE_INFO = {
  left:   { title: 'M\u00c9MOIRE',  count: 12, subtitle: "Tout ce que j'ai appris et retenu", color: '#60a5fa' },
  right:  { title: 'INTELLIGENCE',   count: 14, subtitle: 'Comment je r\u00e9fl\u00e9chis et r\u00e9ponds', color: '#c084fc' },
  bottom: { title: 'WORKERS',        count: 11, subtitle: "L'\u00e9quipe qui travaille 24/7", color: '#22c55e' },
};

// Audio index mapping (matches generate_audio.py order: bottom -> left -> right)
export const AUDIO_OFFSET = { bottom: 0, left: 11, right: 23 };

// Timing constants
const CI = 2.0;   // cascade interval per capability
const SH = 2.0;   // summary hold after cascade
const leftDur   = CAPABILITIES.left.length * CI + SH;
const rightDur  = CAPABILITIES.right.length * CI + SH;
const bottomDur = CAPABILITIES.bottom.length * CI + SH;
const ACCROCHE_DUR = 5, TRANS_DUR = 3, RECON_DUR = 2, FINALE_DUR = 2;
const VOCAL_DUR = 12 * 3.0;
const CLOTURE_DUR = 3, SILENCE_DUR = 2;

// Build timeline sequentially
let _t = 0;
const _m = (d) => { const s = _t; _t += d; return { start: s, end: _t }; };

export const TIMELINE = {
  ACCROCHE:     _m(ACCROCHE_DUR),
  TRANS_BOTTOM: _m(TRANS_DUR),
  BOTTOM:       _m(bottomDur),
  TRANS_LEFT:   _m(TRANS_DUR),
  LEFT:         _m(leftDur),
  TRANS_RIGHT:  _m(TRANS_DUR),
  RIGHT:        _m(rightDur),
  RECON:        _m(RECON_DUR),
  FINALE:       _m(FINALE_DUR),
  TRANS_VOCAL:  _m(TRANS_DUR),
  VOCAL:        _m(VOCAL_DUR),
  CLOTURE:      _m(CLOTURE_DUR),
  SILENCE:      _m(SILENCE_DUR),
  CASCADE_INTERVAL: CI,
  TOTAL: _t,
};
